import { Fragment, useEffect, useState } from "react"

import { useCountry } from "lib/country"
import { useLanguages } from "lib/languages"
import { useProducts } from "lib/products"

import { BlockTitle } from "./block-title"
import { SliderRailProduct } from "./rail-products"

export const SliderProductsMostViewed = ({ rail, isOverlay }) => {
		const { fetchProductsMostViewed, productsMostViewed, getFilms } = useProducts()
		const [filmsMostViewed, setFilmsMostViewed] = useState([])
		const { current: language } = useLanguages()
		const { country } = useCountry()

		useEffect(() => {
			if(!country) {
				return
			}

			if (!productsMostViewed) {
				fetchProductsMostViewed()
				return
			}

			const platformIsoCode = country.isoCode

			getFilms(productsMostViewed[platformIsoCode].map(p => p.productId), language, platformIsoCode)
				.then(films => {
					setFilmsMostViewed(films.slice(0, 8))
				})
				.catch(error => {
					console.log(error)
					setFilmsMostViewed([])
				})
		}, [productsMostViewed, country])

		return (
			<>
				<BlockTitle
					block={rail}
					rail
				/>
				<SliderRailProduct
					productIds={filmsMostViewed}
					withPreview
					isOverlay={isOverlay}
					isSvod
				/>
			</>
		)
}
